module.exports = __webpack_public_path__ + "img/stores-dark-blue.67558449.png";